(() => {
  const DEPOSIT_VARIANT_ID = 51308368068925;
  let depositSyncTimer = null;
  let depositSyncRunning = false;

  async function setPant(value) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: { 'Pant retur': value },
        note: 'Pant – retur av gamle dyser: ' + value
      })
    });

    if (!res.ok) {
      throw new Error(await res.text());
    }

    return res.json();
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });

    if (!res.ok) {
      throw new Error(await res.text());
    }

    return res.json();
  }

  async function changeCart(updates) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ updates })
    });

    if (!res.ok) {
      throw new Error(await res.text());
    }

    return res.json();
  }

  function getBox() {
    return document.getElementById('pant-choice');
  }

  function getCheckedValue(box) {
    const el = box.querySelector('input[name="pant_return_choice"]:checked');
    return el ? el.value : null;
  }

  function shouldUseDeposit(cart) {
    const pantAttr = cart?.attributes?.['Pant retur'] || '';
    if (!pantAttr) return true;
    return pantAttr.toLowerCase().includes('ja');
  }

  function calcRequiredDepositQty(cart) {
    let total = 0;

    for (const item of cart.items) {
      if (item.variant_id === DEPOSIT_VARIANT_ID) continue;

      const raw = item.properties?._dyser_i_pakke || 0;
      const dyser = parseInt(raw, 10);

      if (Number.isFinite(dyser) && dyser > 0) {
        total += dyser * item.quantity;
      }
    }

    return total;
  }

  function getCurrentDepositLine(cart) {
    return cart.items.find((item) => item.variant_id === DEPOSIT_VARIANT_ID);
  }

  async function syncDeposit() {
    if (depositSyncRunning) return;
    depositSyncRunning = true;

    try {
      const cart = await getCart();
      const useDeposit = shouldUseDeposit(cart);
      const currentDepositLine = getCurrentDepositLine(cart);
      const currentDepositQty = currentDepositLine ? currentDepositLine.quantity : 0;
      const requiredDepositQty = useDeposit ? calcRequiredDepositQty(cart) : 0;

      if (currentDepositQty === requiredDepositQty) return;

      const updates = {};
      updates[DEPOSIT_VARIANT_ID] = requiredDepositQty;

      await changeCart(updates);
    } catch (err) {
      console.error('Depositum-sync feilet:', err);
    } finally {
      depositSyncRunning = false;
    }
  }

  function queueDepositSync(delay = 500) {
    clearTimeout(depositSyncTimer);
    depositSyncTimer = setTimeout(() => {
      syncDeposit();
    }, delay);
  }

  function initPantChoice() {
    const box = getBox();
    if (!box) return;

    const current = box.getAttribute('data-current') || '';

    if (!current) {
      const v = getCheckedValue(box);
      if (v) {
        setPant(v)
          .then(() => queueDepositSync(500))
          .catch((e) => console.error('Pant default feilet:', e));
      }
    }

    box.addEventListener('change', async (e) => {
      const el = e.target;
      if (!el || el.name !== 'pant_return_choice') return;

      try {
        await setPant(el.value);
        queueDepositSync(500);
      } catch (err) {
        console.error('Pant lagring feilet:', err);
      }
    });
  }

  function bindCartTriggers() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest(
        'button[name="add"], .product-form__submit, .quantity__button, .cart-remove-button, a[href*="/cart/change"]'
      );
      if (!btn) return;

      queueDepositSync(500);
    });

    document.addEventListener('change', (e) => {
      const el = e.target;
      if (!el) return;

      if (
        el.matches('input[name="quantity"]') ||
        el.matches('input[name="updates[]"]') ||
        el.matches('.quantity__input')
      ) {
        queueDepositSync(500);
      }
    });
  }

  function init() {
    initPantChoice();
    bindCartTriggers();
    queueDepositSync(800);
  }

  document.addEventListener('DOMContentLoaded', init);
})();